(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9184],{

/***/ 78640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_data_maturity; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Hero/Hero.tsx





var copy = {
  heading: "Is your customer data strategy best-in-class?",
  description: "Use Segment\u2019s Customer Data Maturity Model to evaluate your data strategy and receive actionable recommendations on how to improve."
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroComponent, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            tag: "p",
            children: copy.description
          })]
        })
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "egj2ztk1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "egj2ztk0"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/LogoCarousel/LogoCarousel.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var LogoCarousel_copy = {
  heading: "Segment has helped thousands of companies improve their data maturity"
};

var LogoCarousel_LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {
      heading: LogoCarousel_copy.heading
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "esytjss1"
} : 0)(Section/* Wrapper */.im, "{gap:0;padding-top:60px;padding-bottom:0;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel["default"],  true ? {
  target: "esytjss0"
} : 0)( true ? {
  name: "xvginl",
  styles: "max-width:600px"
} : 0);

/* harmony default export */ var components_LogoCarousel_LogoCarousel = (LogoCarousel_LogoCarousel);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Evaluate/Evaluate.tsx


function Evaluate_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Evaluate_button = {
  text: "Take the quiz",
  href: "/customer-data-maturity-evaluation/"
};

var Evaluate = function Evaluate(_ref) {
  var heading = _ref.heading,
      description = _ref.description;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Evaluate_StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
          href: (0,getAbsoluteUrl/* default */.Z)(Evaluate_button.href, pageConfig),
          variant: "filled",
          color: "primary",
          size: "large",
          children: Evaluate_button.text
        })]
      })
    })
  });
};

var Evaluate_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "et0vkwd1"
} : 0)(Section/* Wrapper */.im, "{gap:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:80px;}}" + ( true ? "" : 0));

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "et0vkwd0"
} : 0)( true ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : 0);

/* harmony default export */ var Evaluate_Evaluate = (Evaluate);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/DataVisualization/index.ts + 20 modules
var DataVisualization = __webpack_require__(83001);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/MaturityModel/assets/MaturityModelImageLg.png
var MaturityModelImageLg = __webpack_require__(74711);
var MaturityModelImageLg_default = /*#__PURE__*/__webpack_require__.n(MaturityModelImageLg);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/MaturityModel/assets/MaturityModelImageSm.png
var MaturityModelImageSm = __webpack_require__(39312);
var MaturityModelImageSm_default = /*#__PURE__*/__webpack_require__.n(MaturityModelImageSm);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/MaturityModel/MaturityModelImage.tsx





var sources = {
  src: {
    name: (MaturityModelImageLg_default()),
    width: 1281,
    height: 695
  },
  xs: {
    name: (MaturityModelImageSm_default()),
    width: 655,
    height: 370
  },
  lg: {
    name: (MaturityModelImageLg_default()),
    width: 1281,
    height: 695
  }
};
var MaturityModelImage_copy = {
  heading: "Maturity model overview"
};

var ActImage = function ActImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DataVisualization/* default */.ZP, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataVisualization/* Heading */.X6, {
      children: MaturityModelImage_copy.heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataVisualization/* Figure */.Bc, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataVisualization/* Image */.Ee, {
        sources: sources,
        alt: "Illustration: ".concat(MaturityModelImage_copy.heading),
        width: 640,
        height: 411,
        unoptimized: true
      })
    })]
  });
};

/* harmony default export */ var MaturityModelImage = (ActImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/MaturityModel/MaturityModel.tsx







var data = [{
  heading: "Getting started",
  description: "Your data is fragmented, slow, and untrustworthy",
  color: "#D9D7DB"
}, {
  heading: "Developing",
  description: "You collect data reliably, understand it, and act on it",
  color: "#E12811"
}, {
  heading: "Leading",
  description: "Data drives your KPIs and growth strategy",
  color: "#EA9F5A"
}, {
  heading: "Visionary",
  description: "You lead your category with data-driven user experiences",
  color: "#52BD95"
}];

var MaturityModel = function MaturityModel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MaturityModel_StyledSection, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        children: data.map(function (_ref) {
          var heading = _ref.heading,
              description = _ref.description,
              color = _ref.color;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFeatureBox, {
            alignment: "left",
            color: color,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                variant: "h4",
                children: heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                children: description
              })]
            })
          }, heading);
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaturityModelImage, {})
    })]
  });
};

var MaturityModel_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1g59wob2"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1g59wob1"
} : 0)("max-width:440px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;}" + ( true ? "" : 0));

var StyledFeatureBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1g59wob0"
} : 0)("border-left:4px solid ", function (_ref4) {
  var color = _ref4.color;
  return color;
}, ";padding-left:20px;" + ( true ? "" : 0));

/* harmony default export */ var MaturityModel_MaturityModel = (MaturityModel);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Methodology/Methodology.tsx


function Methodology_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Methodology_copy = {
  heading: "Segment\u2019s Customer Data Maturity Model Methodology",
  descriptions: ["You can only create exceptional customer experiences by investing in your customer data infrastructure. Companies that use customer data effectively can deliver better experiences, make better decisions, and more easily achieve their growth goals.", "To help you understand your strengths and weaknesses when it comes to data maturity, we use these four core competencies:"]
};

var Methodology = function Methodology() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: Methodology_copy.heading
        }), Methodology_copy.descriptions.map(function (description, i) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
            children: description
          }, i);
        })]
      })
    })
  });
};

var Methodology_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1u654671"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e1u654670"
} : 0)( true ? {
  name: "1y0op80",
  styles: "padding-top:14px"
} : 0);

/* harmony default export */ var Methodology_Methodology = (Methodology);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Collect/assets/CollectImage@2x.png
var CollectImage_2x = __webpack_require__(63522);
var CollectImage_2x_default = /*#__PURE__*/__webpack_require__.n(CollectImage_2x);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Collect/assets/CollectImage.webp
var assets_CollectImage = __webpack_require__(99073);
var CollectImage_default = /*#__PURE__*/__webpack_require__.n(assets_CollectImage);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Collect/assets/CollectImage@2x.webp
var assets_CollectImage_2x = __webpack_require__(71101);
var assets_CollectImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectImage_2x);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Collect/CollectImage.tsx








var CollectImage = function CollectImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectImage_default()), ", ").concat((assets_CollectImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (CollectImage_2x_default()),
      alt: "Illustration: Collect your customer data.",
      width: "606",
      height: "484",
      loading: "lazy"
    })]
  });
};

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e15xd5e90"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Collect_CollectImage = (CollectImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Collect/Collect.tsx


function Collect_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Collect_copy = {
  overline: "Collect",
  heading: "How you collect your customer data ",
  description: "Evaluating data collection involves looking at how complete, reliable, and standardized your customer data foundation is."
};

var Collect = function Collect() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collect_SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: Collect_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: Collect_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: Collect_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collect_CollectImage, {})
    })]
  });
};

var Collect_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "euf5bhv0"
} : 0)( true ? {
  name: "1e8a0q1",
  styles: "max-width:440px"
} : 0);

/* harmony default export */ var Collect_Collect = (Collect);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Act/assets/ActImage@2x.png
var ActImage_2x = __webpack_require__(63021);
var ActImage_2x_default = /*#__PURE__*/__webpack_require__.n(ActImage_2x);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Act/assets/ActImage.webp
var assets_ActImage = __webpack_require__(90523);
var ActImage_default = /*#__PURE__*/__webpack_require__.n(assets_ActImage);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Act/assets/ActImage@2x.webp
var assets_ActImage_2x = __webpack_require__(22685);
var assets_ActImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ActImage_2x);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Act/ActImage.tsx








var ActImage_ActImage = function ActImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ActImage_default()), ", ").concat((assets_ActImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActImage_StyledImage, {
      src: (ActImage_2x_default()),
      alt: "Illustration: How you take action using your data.",
      width: "641",
      height: "440",
      loading: "lazy"
    })]
  });
};

var ActImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "elfnio40"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Act_ActImage = (ActImage_ActImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Act/Act.tsx


function Act_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Act_copy = {
  overline: "Act",
  heading: "How you take action using your data",
  description: "The ability to take action on your customer data means customer interactions are personalized consistently in real time across all channels, resulting in lower customer acquisition costs and increased loyalty and customer lifetime value."
};

var Act = function Act() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Act_SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: Act_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: Act_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: Act_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Act_ActImage, {})
    })]
  });
};

var Act_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ehvs90h0"
} : 0)( true ? {
  name: "1e8a0q1",
  styles: "max-width:440px"
} : 0);

/* harmony default export */ var Act_Act = (Act);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Synthesize/assets/SynthesizeImage@2x.png
var SynthesizeImage_2x = __webpack_require__(79634);
var SynthesizeImage_2x_default = /*#__PURE__*/__webpack_require__.n(SynthesizeImage_2x);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Synthesize/assets/SynthesizeImage.webp
var assets_SynthesizeImage = __webpack_require__(19024);
var SynthesizeImage_default = /*#__PURE__*/__webpack_require__.n(assets_SynthesizeImage);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Synthesize/assets/SynthesizeImage@2x.webp
var assets_SynthesizeImage_2x = __webpack_require__(79822);
var assets_SynthesizeImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_SynthesizeImage_2x);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Synthesize/SynthesizeImage.tsx








var SynthesizeImage = function SynthesizeImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((SynthesizeImage_default()), ", ").concat((assets_SynthesizeImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SynthesizeImage_StyledImage, {
      src: (SynthesizeImage_2x_default()),
      alt: "Illustration: How you synthesize your customer data.",
      width: "633",
      height: "397",
      loading: "lazy"
    })]
  });
};

var SynthesizeImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1lbd9w40"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Synthesize_SynthesizeImage = (SynthesizeImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Synthesize/Synthesize.tsx






var Synthesize_copy = {
  overline: "Synthesize",
  heading: "How you synthesize your customer data",
  description: "Synthesis is about turning data points into insights. Best-in-class synthesis means you can achieve a complete view of your customer, make accurate, trusted, audiences and customer profiles accessible to all teams, and generate insights from the data."
};

var Synthesize = function Synthesize() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    copyVariant: "narrow",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Synthesize_SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: Synthesize_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: Synthesize_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: Synthesize_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Synthesize_SynthesizeImage, {})
    })]
  });
};

var Synthesize_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1mq5xme0"
} : 0)("max-width:440px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;}" + ( true ? "" : 0));

/* harmony default export */ var Synthesize_Synthesize = (Synthesize);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Adapt/assets/AdaptImage@2x.png
var AdaptImage_2x = __webpack_require__(62032);
var AdaptImage_2x_default = /*#__PURE__*/__webpack_require__.n(AdaptImage_2x);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Adapt/assets/AdaptImage.webp
var assets_AdaptImage = __webpack_require__(36822);
var AdaptImage_default = /*#__PURE__*/__webpack_require__.n(assets_AdaptImage);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/components/Adapt/assets/AdaptImage@2x.webp
var assets_AdaptImage_2x = __webpack_require__(41841);
var assets_AdaptImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AdaptImage_2x);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Adapt/AdaptImage.tsx








var AdaptImage = function AdaptImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((AdaptImage_default()), ", ").concat((assets_AdaptImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdaptImage_StyledImage, {
      src: (AdaptImage_2x_default()),
      alt: "Illustration: How you adapt to changes in your business or industry",
      width: "633",
      height: "397",
      loading: "lazy"
    })]
  });
};

var AdaptImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1p1pht10"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Adapt_AdaptImage = (AdaptImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/Adapt/Adapt.tsx






var Adapt_copy = {
  overline: "Adapt",
  heading: "How you adapt to changes in your business or industry",
  description: "Adaptable customer data means it\u2019s universally accessible, and easy to manage and change as new technologies emerge."
};

var Adapt = function Adapt() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Adapt_SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: Adapt_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: Adapt_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: Adapt_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Adapt_AdaptImage, {})
    })]
  });
};

var Adapt_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1h1vrh70"
} : 0)("max-width:440px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;}" + ( true ? "" : 0));

/* harmony default export */ var Adapt_Adapt = (Adapt);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/components/GettingStarted/GettingStarted.tsx










var GettingStarted_copy = {
  heading: "Take your data maturity \n to the next level with Segment",
  button: {
    text: "Create a free account"
  },
  demoButton: {
    text: "Get a demo",
    href: "/demo/"
  }
};

var GettingStarted = function GettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          children: GettingStarted_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "outlined",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)(GettingStarted_copy.demoButton.href, pageConfig),
          children: GettingStarted_copy.demoButton.text
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: GettingStarted_copy.button.text
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hdmpl52"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hdmpl51"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;white-space:pre-line;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hdmpl50"
} : 0)("display:grid;max-width:520px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturity/assets/OgImage.jpg
var OgImage = __webpack_require__(10991);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturity/CustomerDataMaturity.tsx



















var CustomerDataMaturity_copy = {
  pageTitle: "Customer Data Maturity Model. Evaluate your data today! | Twilio Segment",
  pageDescription: "Evaluate your company\u2019s data strategy and we\u2019ll give you actionable and personalized recommendations on how to improve with Twilio Segment\u2019s Customer Data Maturity Model.",
  evaluateTop: {
    heading: "Evaluate your data maturity in 5 minutes",
    description: "Fill out the four question evaluation and we\u2019ll give you actionable and personalized recommendations. It\u2019s quick, easy, and helpful."
  },
  evaluateBottom: {
    heading: "Evaluate your data strategy today",
    description: "Start the quiz below and we\u2019ll help you identify if your customer data strategy is best-in-class."
  }
};

var CustomerDataMaturityView = function CustomerDataMaturityView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerDataMaturity_copy.pageTitle,
      pageDescription: CustomerDataMaturity_copy.pageDescription,
      pageOG: (OgImage_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Evaluate_Evaluate, {
          heading: CustomerDataMaturity_copy.evaluateTop.heading,
          description: CustomerDataMaturity_copy.evaluateTop.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaturityModel_MaturityModel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_Methodology, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collect_Collect, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Synthesize_Synthesize, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Act_Act, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Adapt_Adapt, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Evaluate_Evaluate, {
          heading: CustomerDataMaturity_copy.evaluateBottom.heading,
          description: CustomerDataMaturity_copy.evaluateBottom.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "esj84uf0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CustomerDataMaturity_CustomerDataMaturity = (CustomerDataMaturityView);
;// CONCATENATED MODULE: ./src/pages/customer-data-maturity/index.tsx



var CustomerDataMaturity = function CustomerDataMaturity() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerDataMaturity_CustomerDataMaturity, {});
};

/* harmony default export */ var customer_data_maturity = (CustomerDataMaturity);

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 79409:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-data-maturity",
      function () {
        return __webpack_require__(78640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10991:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-821b7f6403ebd2cbccf5382a86f7f4f0.jpg";

/***/ }),

/***/ 63021:
/***/ (function(module) {

module.exports = "/_next/static/images/ActImage@2x-1f419f901a892274dc52e12edf4be7a7.png";

/***/ }),

/***/ 62032:
/***/ (function(module) {

module.exports = "/_next/static/images/AdaptImage@2x-2033d98b08153b3c597c3b75319bb05f.png";

/***/ }),

/***/ 63522:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectImage@2x-e730d2c248ce39984dbdf91d2ce01662.png";

/***/ }),

/***/ 74711:
/***/ (function(module) {

module.exports = "/_next/static/images/MaturityModelImageLg-dc6a0717f401bc9616e48d6661097ea3.png";

/***/ }),

/***/ 39312:
/***/ (function(module) {

module.exports = "/_next/static/images/MaturityModelImageSm-f47f1ae098ba5bf72d5dba93aca0edb5.png";

/***/ }),

/***/ 79634:
/***/ (function(module) {

module.exports = "/_next/static/images/SynthesizeImage@2x-72602f8727ab6d18b96f2096b92928af.png";

/***/ }),

/***/ 90523:
/***/ (function(module) {

module.exports = "/_next/static/images/ActImage-b32556028fee369a1fd385f6b7dfcd61.webp";

/***/ }),

/***/ 22685:
/***/ (function(module) {

module.exports = "/_next/static/images/ActImage@2x-ce259f3d2a3ad02b465403b570778ebd.webp";

/***/ }),

/***/ 36822:
/***/ (function(module) {

module.exports = "/_next/static/images/AdaptImage-8b631063e827fea507103c40a60fdc43.webp";

/***/ }),

/***/ 41841:
/***/ (function(module) {

module.exports = "/_next/static/images/AdaptImage@2x-01260089d9c3545e89d470132f225a8b.webp";

/***/ }),

/***/ 99073:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectImage-bacfa270b3dc36b805a190ba803bdaa9.webp";

/***/ }),

/***/ 71101:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectImage@2x-eca12c946f5f6b14a04a3e1144a4aac1.webp";

/***/ }),

/***/ 19024:
/***/ (function(module) {

module.exports = "/_next/static/images/SynthesizeImage-efa9aebdece00cbf66c10378e481b3d3.webp";

/***/ }),

/***/ 79822:
/***/ (function(module) {

module.exports = "/_next/static/images/SynthesizeImage@2x-67d9f1bfbe71506ee609da8bde6ddbf3.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,3627,1382,4136,2073,8392,5735,2429,7303,8187,442,7079,1385,3379,5062,338,9774,2888,179], function() { return __webpack_exec__(79409); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);